/**
 * Component that renders a single toast notification.
 * Meant to be rendered via renderToast().
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {pageWidth, zindexAboveModal} from "@khan/shared-styles";

interface ToastNotificationProps {
    children: React.ReactNode;
    position?: "top right" | "bottom center";
    testId?: string;
}

export function ToastNotification({
    children,
    position = "top right",
    testId,
}: ToastNotificationProps) {
    return (
        <div
            className={css(
                styles.toast,
                position === "top right"
                    ? styles.topRightToast
                    : styles.bottomCenterToast,
            )}
        >
            <View testId={testId}>{children}</View>
        </div>
    );
}

// These styles could live in BaseToastNotification, but it would make
// it harder to test individual toast notifications via fixtures.
const styles = StyleSheet.create({
    toast: {
        // Toast notifications should always be visible
        position: "fixed",
        zIndex: zindexAboveModal,
    },
    topRightToast: {
        top: 57,
        insetInlineEnd: 0,

        // Keep toast notifications aligned to the right edge of the page
        [`@media screen and (min-width: ${pageWidth}px)`]: {
            insetInlineEnd: `calc((100% - ${pageWidth}px) / 2)`,
        },
    },
    bottomCenterToast: {
        bottom: spacing.medium_16,
        insetInlineStart: "50%",
        transform: "translate(-50%)",
    },
});
